import { render, staticRenderFns } from "./TestReportDetail.vue?vue&type=template&id=5a2bfd8a&scoped=true&"
import script from "./TestReportDetail.vue?vue&type=script&lang=js&"
export * from "./TestReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./TestReportDetail.vue?vue&type=style&index=0&id=5a2bfd8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2bfd8a",
  null
  
)

export default component.exports